<app-pan-card
  [isPageContainer]="true"
  [header]="'Upload Priorities CSV'"
  [subheader]="'Current priority location count: ' + (locationPriorityCount() | number)"
  pageContainerSize="xl"
>
  <div (files)="filesDropped($event)" class="flex items-center justify-center w-full" panDragDropFiles>
    <label
      class="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
      for="dropzone-file"
    >
      <div class="flex flex-col items-center justify-center py-6">
        <mat-icon class="text-gray-500">cloud_upload</mat-icon>
        <p class="mb-2 text-md text-gray-500"><span class="font-semibold">Click to upload</span> or drag and drop</p>
        <p class="text-xs text-gray-500">SVG, PNG, JPG or GIF (MAX. 800x400px)</p>
      </div>
      <input (change)="onCsvPicked($event)" class="hidden" id="dropzone-file" type="file" />
    </label>
  </div>

  <div role="status" [ngClass]="{ block: isUpdating, hidden: !isUpdating }">
    <app-pan-blank-slate>
      <app-pan-spinner></app-pan-spinner>
      <span class="sr-only">Loading...</span>
    </app-pan-blank-slate>
  </div>
</app-pan-card>
